module.exports = __webpack_public_path__ + "static/media/orientation-to-vertical.f525cf2a.png";